import { render, staticRenderFns } from "./Correct.vue?vue&type=template&id=79047d48&scoped=true&"
import script from "./Correct.vue?vue&type=script&lang=js&"
export * from "./Correct.vue?vue&type=script&lang=js&"
import style0 from "./Correct.vue?vue&type=style&index=0&id=79047d48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79047d48",
  null
  
)

export default component.exports